var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            visible: _vm.isShowHint,
            center: "",
            title: "提示",
            top: "25vh",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowHint = $event
            },
          },
        },
        [
          _c(
            "span",
            { staticStyle: { "font-weight": "bold", "font-size": "1.1em" } },
            [_vm._v(_vm._s(_vm.productData.msgHint))]
          ),
          _c("div", { staticStyle: { "margin-top": "10px" } }),
          _c("template", { slot: "footer" }, [
            _c(
              "div",
              { staticClass: "u-flex-col u-col-center" },
              _vm._l(_vm.productData.productList, function (itemData, index) {
                return _c(
                  "el-button",
                  {
                    key: index,
                    staticStyle: { margin: "5px" },
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.onChoiceType(index)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(itemData.memo) + "\n\t\t\t\t"
                    ),
                  ]
                )
              }),
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            visible: _vm.isShowInsureHint,
            center: "",
            title: "提示",
            top: "25vh",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowInsureHint = $event
            },
          },
        },
        [
          _vm.isXsmJianzhu(_vm.currentChoiceData.insureType)
            ? _c("div", { staticClass: "insure-hint" }, [
                _vm._v(
                  "\n\t\t\t广东企业灵活用工保的方案，请注意第4项拒保的职业都不保的，请留意本方案：\n\t\t\t1、身故与残疾的情况下出险必须要有安全带及高空等特种作业证，没有其一的话会有25%的免赔；\n\t\t\t2、出险请务必72小时内报案，超时报案免赔50%没有通融的\n\t\t\t3、方案不减员，1个月、3个月保单不能替换，出过险的人员不能替换。 4、伤残使用的是新残标《人体损伤致伤残鉴定标准》\n\t\t\t5、仅门诊治疗没有误工费，出险须到二级及以上公立医院就诊才能赔，医疗社保范围内100%赔付；\n\t\t\t6、1-3类职业不保高空，4-6类职业可保高空。\n\t\t"
                ),
              ])
            : _c("div", { staticClass: "insure-hint" }, [
                _vm._v(
                  "\n\t\t\t广东制造行业雇主险的方案，请注意本方案除制造行业的职业都不保的，请留意本方案：\n\t\t\t1、身故与残疾的情况下出险必须要有安全带及高空等特种作业证，没有其一的话会有25%的免赔；\n\t\t\t2、出险请务必72小时内报案，超时报案免赔50%没有通融的； 3、方案只能年保，本方案中途申请退保或批减，可退保费为0；\n\t\t\t4、伤残使用工标十级5%起；\n\t\t\t5、仅门诊治疗没有误工费，出险须到二级及以上公立医院就诊才能赔，医疗社保范围内100%赔付；\n\t\t\t6、1-3类职业不保高空，4-6类职业可保高空； 7、扩展24小时意外医疗，非工作时间死亡伤残赔付不超过投保额的50%；\n\t\t\t8、猝死赔付责任为投保限额的20%； 9、只保工作场所在广东的广东企业。\n\t\t"
                ),
              ]),
          _c("template", { slot: "footer" }, [
            _c(
              "div",
              { staticClass: "u-flex-row u-row-center" },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { margin: "0 10px" },
                    attrs: { plain: "", type: "primary" },
                    on: {
                      click: function ($event) {
                        _vm.isShowInsureHint = false
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t谢谢，投/被保险人不同意此告知\n\t\t\t\t"
                    ),
                  ]
                ),
                _c(
                  "el-button",
                  {
                    staticStyle: { margin: "0 10px" },
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.onChoiceType(3)
                      },
                    },
                  },
                  [_vm._v("投/被保险人均已知悉")]
                ),
              ],
              1
            ),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }